export class ReturnForCredit {
  constructor() {
    this._refs = {
      orderlinesValue: document.querySelector('[data-orderlines]'),
      serialNumbersValue: document.querySelector('[data-serial-numbers]'),
      orderlineWrapper: document.querySelectorAll('.return_items__wrapper'),
      availableCheckboxes: document.querySelectorAll(
        '.return_items__wrapper input[type="checkbox"]:not(:disabled)',
      ),
      totalSelected: document.querySelector('.return_total-selected'),
      submitButton: document.querySelector('.submit_order--button'),
      //to be changed in future - needs an id or some unique identifier from BE in order to be done, all the return* should be done with some unique id
      returndd: document.querySelector('.configurator__dropdown .form-select select'),
      returnCheckbox: document.querySelector('.return_reason__issue .configuratorcheckbox'),
      returnComment: document.querySelector('.return_reason__issue textarea'),
      deselectOrderLines: document.querySelector('.return_reason__deselect'),
      categoriesOptions: document.querySelectorAll('[data-id="MultiselectOption"]'),
      returnReasonsContainer: document.querySelector('.configurator__multiselect-wrapper'),
      multipleSerialNumberItem: document.querySelectorAll(
        '.return_items__product_list-item--multiple',
      ),
      reasonOptions: null,
      pimSettings: {
        url: `${window.location.origin}/api/pim/getColorImageAssets`,
        filetype: 'psd',
      },
      trashIcons: null,
      selectedDropDownOption: null,
      shownOptionsCount: document.querySelectorAll('.shownOptionsCount'),
    };

    // Orderline
    this._refs.availableCheckboxes.forEach((x) =>
      x.addEventListener('change', this._orderlineCheckboxChange.bind(this)),
    );
    this._refs.deselectOrderLines.addEventListener(
      'click',
      this._selectDeselectAllOrderlines.bind(this),
    );
    if (this._refs.multipleSerialNumberItem) {
      this._interpolateSelected();
      Array.from(this._refs.multipleSerialNumberItem).forEach((itemEl) => {
        Array.from(itemEl.querySelectorAll('.return_items__content')).forEach((contentEl) => {
          contentEl.addEventListener('click', this._toggleReturnOrderDropdown);
        });

        Array.from(itemEl.querySelectorAll('.form-control')).forEach((searchEl) => {
          searchEl.addEventListener('keyup', this._onSearchSerialNumber);
        });
      });
    }

    // Return reason
    this._refs.returndd?.addEventListener('change', this._returnReasonChange.bind(this));
    this._refs.returnCheckbox?.addEventListener('change', this._devicesSealedChange.bind(this));
    this._refs.returnComment?.addEventListener('blur', this._addComment.bind(this));
    this._refs.returnReasonsContainer?.addEventListener(
      'click',
      this._updateReturnReasons.bind(this),
    );
    this._refs.categoriesOptions.forEach((x) =>
      x.addEventListener('click', this._disableEnableSubmit.bind(this)),
    );
    this._refs.shownOptionsCount.forEach((x) => (x.innerText = '(0)'));
    this._init();
  }

  async _init() {
    this._setInitialValues();
  }

  get selectedSerialNumber() {
    return [...this._refs.availableCheckboxes].filter((el) => el.checked).length;
  }

  get selectedOrderLine() {
    let count = 0;
    Array.from(this._refs.orderlineWrapper).forEach((el) => {
      const checkboxes = el.querySelectorAll('.return_items__wrapper input[type="checkbox"]');
      const allSelected = checkboxes?.length === [...checkboxes].filter((el) => el.checked).length;

      if (allSelected) {
        count++;
      }
    });

    return count;
  }

  _orderlineCheckboxChange(e) {
    this._refs.orderlinesValue.innerText = this.selectedOrderLine;
    this._refs.serialNumbersValue.innerText = this.selectedSerialNumber;
    this._refs.totalSelected.innerText = this.selectedSerialNumber;

    if (e.srcElement.checked) {
      if (this._refs.totalSelected.innerText == this._refs.availableCheckboxes.length) {
        this._refs.deselectOrderLines.dataset.deselect = 'true';
      }
    } else {
      if (parseFloat(this._refs.totalSelected.innerText) == 0) {
        this._refs.deselectOrderLines.dataset.deselect = 'false';
      }
    }
    this._disableEnableSubmit();
    this._interpolateSelected();
  }

  _setInitialValues() {
    this._refs.totalSelected.innerText = this.selectedSerialNumber;
    this._refs.orderlinesValue.innerText = this.selectedOrderLine;
    this._refs.serialNumbersValue.innerText = this.selectedSerialNumber;
    this._disableEnableSubmit();
  }

  _returnReasonChange() {
    const selectedDropDownOption = this._refs.returndd.options[this._refs.returndd.selectedIndex];
    const returnReasonDropDownValue = selectedDropDownOption.innerHTML;
    const selectedOptionHasValue = selectedDropDownOption.value; //to avoid passing "Selected" as a return reason in summary
    const htmlElement = document.querySelector(
      '.return-for-credit_summary-details .return_info-select',
    );
    const reasonsLabel = document.querySelector('.return_reason__title').innerHTML;
    this._refs.selectedDropDownOption = selectedDropDownOption;
    if (returnReasonDropDownValue && selectedOptionHasValue) {
      htmlElement.innerHTML = this._returnReasonDetailsTemplate(
        reasonsLabel,
        returnReasonDropDownValue,
      );
      htmlElement.classList.remove('hiddenInfo');
    } else {
      htmlElement.innerHTML = '';
      htmlElement.classList.add('hiddenInfo');
    }
    this._disableEnableSubmit();
  }

  _onSearchSerialNumber(elem) {
    const options =
      elem.srcElement.offsetParent.nextElementSibling.querySelectorAll('.form-select__list-item');
    Array.from(options).forEach((option) => {
      const val = option.dataset.optionValue;
      const match = val.includes(elem.target.value.trim());
      if (match || !elem.target.value.trim()) {
        option.classList.remove('hidden');
      } else {
        option.classList.add('hidden');
      }
    });
  }

  _toggleReturnOrderDropdown(elem) {
    elem.srcElement.offsetParent.classList.toggle('is-active');
  }

  _returnReasonDetailsTemplate(title, text) {
    return `
            <div class="configurator_info__title">${title}</div>
            <div class="configurator_info__value">${text}</div>
        `;
  }

  _devicesSealedChange() {
    const htmlElement = document.querySelector(
      '.return-for-credit_summary-details .return_info-checkbox',
    );
    if (this._refs.returnCheckbox.querySelector('input').checked) {
      const devicesLabel = this._refs.returnCheckbox.querySelector('label').innerText;
      const devicesValue = document.querySelector('#YesLabel').value;
      htmlElement.innerHTML = this._returnReasonDetailsTemplate(devicesLabel, devicesValue);
      htmlElement.classList.remove('hiddenInfo');
    } else {
      htmlElement.innerHTML = '';
      htmlElement.classList.add('hiddenInfo');
    }
  }

  _addComment() {
    const htmlElement = document.querySelector(
      '.return-for-credit_summary-details .return_info-textarea',
    );
    const commentValue = this._refs.returnComment.value;
    if (commentValue) {
      const commentLabel = this._refs.returnComment.labels[0].innerText;
      htmlElement.innerHTML = this._returnReasonDetailsTemplate(commentLabel, commentValue);
      htmlElement.classList.remove('hiddenInfo');
    } else {
      htmlElement.innerHTML = '';
      htmlElement.classList.add('hiddenInfo');
    }
  }

  _updateReturnReasons() {
    const htmlElement = document.querySelector(
      '.return-for-credit_summary-details .return_info-textarea',
    );
    setTimeout(() => {
      const reasonOptions = this._refs.reasonOptions;
      if (reasonOptions) {
        const reasonsLabel = document.querySelector('.return_reason__title').innerHTML;
        let reasonValues = '';
        reasonOptions.forEach((reason, index) => {
          const separator = index > 0 ? ', ' : '';
          reasonValues = `${reasonValues}${separator}${reason.innerText}`;
        });
        htmlElement.innerHTML = this._returnReasonDetailsTemplate(reasonsLabel, reasonValues);
      } else {
        htmlElement.innerHTML = '';
      }
      this._refs.trashIcons = document.querySelectorAll('.eva-trash-2-outline');
      this._refs.trashIcons.forEach((x) =>
        x.addEventListener('click', this._handleTrashClick.bind(this)),
      );
    }, 0);
  }

  _disableEnableSubmit() {
    const selectedDropDownOption = this._refs.selectedDropDownOption;
    setTimeout(() => {
      this._refs.reasonOptions = document.querySelectorAll(
        '.configurator__multiselect-chosenoptions_option',
      );
      const returnReasonDropDownValue = selectedDropDownOption?.innerHTML;
      const selectedOptionHasValue = selectedDropDownOption?.value; //to avoid passing "Selected" as a return reason in summary
      const isReasonOptionChosen = Boolean(this._refs.reasonOptions?.length);
      const shouldBeEnabled =
        (this.selectedSerialNumber && isReasonOptionChosen) ||
        (this.selectedSerialNumber && returnReasonDropDownValue && selectedOptionHasValue);
      this._refs.submitButton.disabled = !shouldBeEnabled;
    }, 0);
  }

  _handleTrashClick() {
    this._disableEnableSubmit();
  }

  _selectDeselectAllOrderlines() {
    const updateSelected = () => {
      const isSelected = this._refs.deselectOrderLines.dataset.deselect;
      this._refs.availableCheckboxes.forEach((el) =>
        isSelected === 'false' ? (el.checked = true) : (el.checked = false),
      );

      if (isSelected == 'true') {
        this._refs.totalSelected.innerText = 0;
        this._refs.orderlinesValue.innerText = 0;
        this._refs.serialNumbersValue.innerText = 0;
      } else {
        this._refs.totalSelected.innerText = this.selectedSerialNumber;
        this._refs.orderlinesValue.innerText = this.selectedOrderLine;
        this._refs.serialNumbersValue.innerText = this.selectedSerialNumber;
      }
      this._refs.deselectOrderLines.dataset.deselect = isSelected === 'false' ? 'true' : 'false';
    };

    updateSelected();
    this._interpolateSelected();
    this._disableEnableSubmit();
  }

  _interpolateSelected() {
    Array.from(this._refs.multipleSerialNumberItem).forEach((item) => {
      const checkboxes = item.querySelectorAll('.form-select__list-item input[type="checkbox"]');
      const total = checkboxes.length;
      const count = [...checkboxes].filter((el) => el.checked).length;
      const labelElement = item.querySelector('.return_items__product_list-multiple--label');

      if (!labelElement) return;

      const selectedLabel = labelElement?.dataset.label ?? '';
      labelElement.innerHTML = selectedLabel
        .replace('{{count}}', count)
        .replace('{{total}}', total);
    });
  }
}
